import { RefObject } from "react";

export function createClickOutsideHandler(opts: {
  isOpen: () => boolean;
  ref: RefObject<HTMLElement>;
  onOutside: () => void;
}) {
  return function handleClickOutside(event: MouseEvent) {
    if (!opts.isOpen()) return;

    const el = opts.ref.current;
    if (!el) return;

    const path = event.composedPath?.() ?? [];
    const clickedInside =
      path.includes(el) ||
      (event.target instanceof Node && el.contains(event.target));

    if (!clickedInside) {
      opts.onOutside();
    }
  };
}
